/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ChangePwAliases {
  BUTTON_CHANGE_PW = 'button-change-pw',
  BUTTON_OK = 'button-ok',
  FIELD_CURRENT_PW = 'field-current-pw',
  FIELD_NEW_PW = 'field-new-pw',
  FIELD_NEW_PW_CONFIRM = 'field-new-pw-confirm',
  FORM_CHANGE_PW = 'form-change-pw',
  IMAGE_0 = 'image-0',
  INPUT_CURRENT_PW = 'input-current-pw',
  INPUT_NEW_PW = 'input-new-pw',
  INPUT_NEW_PW_CONFIRM = 'input-new-pw-confirm',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LAYOUT_2 = 'layout-2',
  LOADER = 'loader',
  MODAL = 'modal',
  MODAL_SUCCESS = 'modal-success',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_BUTTON = 'panel-button',
  PANEL_FORM = 'panel-form',
  PANEL_LOADER = 'panel-loader',
  PANEL_MODAL = 'panel-modal',
  PANEL_SUCCESS = 'panel-success',
  PANEL_TOAST = 'panel-toast',
  TEXT_0 = 'text-0',
  TOAST_CHANGE_PW = 'toast-change-pw',
}
export { ChangePwAliases };
